import type { StyleConfigProps } from '../types';

export const FOOTNOTE_VARIANTS = ['Regular', 'Bold'] as const;

export const FOOTNOTE_CONFIG: StyleConfigProps<typeof FOOTNOTE_VARIANTS> = {
  Regular: {
    fontWeight: 400,
    fontSize: '11px',
    lineHeight: '15px',
  },
  Bold: {
    fontWeight: 700,
    fontSize: '11px',
    lineHeight: '15px',
  },
};
